import { KnBrAcknowledgeModule } from './kn-br-acknowledge/kn-br-acknowledge.module';
import { KnBrReturnOrderModule } from './kn-br-return-order/kn-br-return-order.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { knBrCustomer360EndpointsConfig } from '../../occ/kn-br-customer360-endpoints.config';
import { ADDRESS_NORMALIZER, ADDRESS_SERIALIZER, ConfigModule } from '@spartacus/core';
import { ORDER_NORMALIZER, ORDER_RETURN_REQUEST_NORMALIZER } from '@spartacus/order/root';
import { KnBrOrderHistoryModule } from './kn-br-order-history/kn-br-order-history.module';
import { KnBrOrderDetailModule } from './kn-br-order-detail/kn-br-order-detail.module';
import { KnBrReturnOrderListModule } from './kn-br-return-order-list/kn-br-return-order-list.module';
import { KnBrInvoiceListModule } from './kn-br-invoice-list/kn-br-invoice-list.module';
import { KnBrReturnOrderDetailModule } from './kn-br-return-order-detail/kn-br-return-order-detail.module';
import { KnBrAddressBookModule } from './kn-br-address-book/kn-br-address-book.module';
import { KnBrFactSheetModule } from './kn-br-fact-sheet/kn-br-fact-sheet.module';
import { KnBrCustomer360HomeModule } from './kn-br-customer360-home/kn-br-customer360-home.module';
import { KnBrOrderNormalizer } from 'src/feature-libs/kn-br-order/root/converters/kn-br-order.converter';
import { KnBrAddressSerializer } from 'src/app/serializer/kn-br-address.serializer';
import { KnBrReturnOrderNormalizer } from '../../root/converters/kn-br-return-order.converter';
import { KnBrAddressNormalizer } from '../../root/converters/kn-br-address.converter';

@NgModule({
  imports: [
    CommonModule,
    KnBrOrderHistoryModule,
    KnBrOrderDetailModule,
    KnBrReturnOrderModule,
    KnBrAcknowledgeModule,
    KnBrInvoiceListModule,
    KnBrReturnOrderListModule,
    KnBrReturnOrderDetailModule,
    KnBrAddressBookModule,
    KnBrFactSheetModule,
    KnBrCustomer360HomeModule,
    //ConfigModule.withConfig(knBrCustomer360EndpointsConfig),
  ],
  providers: [
    {
      provide: ORDER_NORMALIZER,
      useClass: KnBrOrderNormalizer,
      multi: true,
    },
    {
      provide: ORDER_RETURN_REQUEST_NORMALIZER,
      useClass: KnBrReturnOrderNormalizer,
      multi: true,
    },
    {
      provide: ADDRESS_NORMALIZER,
      useClass: KnBrAddressNormalizer,
      multi: true,
    },
    {
      provide: ADDRESS_SERIALIZER,
      useClass: KnBrAddressSerializer,
      multi: true,
    },
  ],
  declarations: [],
})
export class KnBrCustomer360Module { }
